import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Images
import salesBanner from '../../assets/img/partnerPortal/sales/Half Wave.svg';
import arrowLeft from '../../assets/img/general/arrow-left.svg';

// Scss
import '../../assets/css/partnerProgram.scss';
import Title from "../../components/Title";

function BootcampOpenSoon() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  const TITLE = "Bootcamp registrations closed";
  const SUB_TITLE = "Sorry, registrations of this bootcamp are not open yet. Registrations will open closer to the bootcamp date. Subscribe to enablement notifications to get informed when registrations are open.";
  const BUTTON_NAME = "Enablement notifications";
  const BUTTON_LINK= "https://partners.dynatrace.com/#/page/enablement";

  return (
    <>
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center mb-3 w-100">
                <img src={salesBanner} className=' shadow-4 imageBannerSales' alt='...' />
                <div className="d-flex row w-100 marginsAssociate">
                    <div className="d-flex pt-4 flex-column align-items-start justify-content-center width42 mr-5">
                        <div className="d-flex align-items-start pb-4">
                            <Title classNameText="salesTitle" title={TITLE} withoutLine={true}/>
                        </div>
                        <div className="d-flex align-items-start">
                            <div className="subCopyLetters mb-3">
                                {SUB_TITLE}
                            </div>
                        </div>
                        <div className="d-flex flex-column align-items-center align-self-stretch mt-3">
                            <div className="d-flex flex-column align-items-start justify-content-center w-100">
                                <a href={BUTTON_LINK} target="_parent"  >
                                    <div className="d-flex align-items-start justify-content-center">
                                        <img src={arrowLeft}  alt='...' width={"12%"}  />
                                        <div className="d-flex flex-column align-items-start w-100 ChangeLineColor">
                                            <div className="d-flex align-items-start bootcampClosedBlue">{BUTTON_NAME}</div>
                                            <div className="lineBlue"></div>

                                        </div>
                                    </div>
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default BootcampOpenSoon;

